import { GearIcon, TrashCanIcon } from "@/components/icon";
import RoundedButton from "@/components/UI/RoundedButton";
import { useState } from "react";
import { Popconfirm } from "antd";
import { useNavigate } from "react-router";
import { useDeleteQuoteLine } from "@/common/api/mutation";
import { toast } from "react-toastify";
import { queryClient } from "@/common/utils";
import { usePermissions } from "@/common/contexts/Permissions.context";

export default function AIRXQuoteActions({
  quoteLine,
  source,
}: {
  quoteLine: any;
  source: "vendor" | "customer";
}) {
  const {isHavePermission} = usePermissions()
  const navigate = useNavigate();
  const [popConfirm, setPopConfirm] = useState<boolean>(false);
  const { mutate } = useDeleteQuoteLine();
  const navigateToQuoteLine = () => {
    return navigate(`/quoteLine/airx/${quoteLine.quote.id}/${quoteLine?.id}`, {
      state: {
        source,
      },
    });
  };
  return (
    <div className="flex gap-2">
      <RoundedButton
        className="bg-primaryDim"
        icon={<GearIcon />}
        func={navigateToQuoteLine}
      />
     {isHavePermission(`quotes_${source}_delete`) && <Popconfirm
        title="Delete this Quote Line"
        placement="rightTop"
        description="Are you sure you want to delete this Quote Line?"
        onConfirm={() => {
          return mutate(quoteLine.id, {
            onSuccess: () => {
              toast.success("Quote line deleted");
              queryClient.invalidateQueries();
              setPopConfirm(false);
            },
          });
        }}
        trigger="click"
        okText="Yes"
        cancelText="No"
        open={popConfirm}
        onCancel={() => setPopConfirm(false)}
      >
        <RoundedButton
          className="text-error bg-red-light"
          icon={<TrashCanIcon />}
          func={() => setPopConfirm(true)}
        />
      </Popconfirm>}
    </div>
  );
}
